import type { JobListingCardStatus } from '@tempmee/core';
import { JobPostingStatus } from '~/domain/PermanentJobs';

/**
 * Maps the portal's {@link JobPostingStatus} onto the design-system
 * `JobListingCard` status union. The enum values already match the union
 * members, but the explicit map keeps the two contracts decoupled.
 */
export const STATUS_MAP: Record<JobPostingStatus, JobListingCardStatus> = {
  [JobPostingStatus.Active]: 'active',
  [JobPostingStatus.Closed]: 'closed',
  [JobPostingStatus.Draft]: 'draft',
  [JobPostingStatus.Suspended]: 'suspended',
};
